import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Auth.css';

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [debugInfo, setDebugInfo] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setDebugInfo('');
    setLoading(true);

    try {
      setDebugInfo('Logging in...');
      
      // Login - this saves the token internally
      const response = await authAPI.login(email, password);
      setDebugInfo(`Login OK (${response.status}), getting user...`);
      
      // Get user info - this saves user data internally
      const userResponse = await authAPI.getCurrentUser();
      setDebugInfo(`User OK (${userResponse.status}), redirecting...`);
      
      // Notify parent that login succeeded
      if (onLoginSuccess) {
        onLoginSuccess();
      }
      
      // Notify WalletContext that auth is ready (so it loads wallets)
      window.dispatchEvent(new Event('authReady'));
      
      // Redirect to dashboard
      navigate('/analytics');
    } catch (err) {
      console.error('[Login] Error:', err);
      const errorMsg = err.response?.data?.detail || err.message || 'Login failed';
      setError(errorMsg);
      setDebugInfo(`Error: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>DomusAI</h1>
        <h2>Login</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
              autoComplete="email"
            />
          </div>
          
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>
          
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        {debugInfo && (
          <div style={{ 
            marginTop: '10px', 
            padding: '8px', 
            background: '#f0f0f0', 
            borderRadius: '4px',
            fontSize: '12px',
            color: '#666'
          }}>
            {debugInfo}
          </div>
        )}
        
        <p className="auth-link">
          Don't have an account? <Link to="/signup">Sign up</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
